import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Label = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._500};
  margin-right: 8px;
`;
export const Wrap = styled.div`
  display: flex;
  align-items: center;
`;
export const ErrorWrap = styled.div`
  ${({ big }) =>
    big &&
    css`
      height: 16px;
      margin-top: 8px;
    `}

  display: flex;
  align-items: center;

  align-self: flex-start;
  img,
  svg {
    height: 20px;
    min-width: 20px;
    max-width: 20px;
  }
`;

export const ErrorText = styled.span`
  color: ${() => Palette.Red._500};
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-left: 8px;
`;

export const BigContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const SmallContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BigWrap = styled.div`
  display: flex;
`;

export const SmallWrap = styled.div`
  display: flex;
`;

export const Currency = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  min-width: 28px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 4px 0 0 4px;
  border-right-style: none;
  user-select: none;
`;

export const LabelCurrency = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  min-width: 81px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 4px 0 0 4px;
  border-right-style: none;
`;

export const InputWrapp = styled.div`
  div {
    max-height: 32px;
  }
`;
